__turbopack_context__.v({
  "active": "c-YbCW_active",
  "hoverIcon": "c-YbCW_hoverIcon",
  "icon": "c-YbCW_icon",
  "iconContainer": "c-YbCW_iconContainer",
  "left": "c-YbCW_left",
  "right": "c-YbCW_right",
  "searchButton": "c-YbCW_searchButton",
});
